import { render } from "./AdminUserManagementTable.vue?vue&type=template&id=f2c54478&scoped=true"
import script from "./AdminUserManagementTable.vue?vue&type=script&lang=js"
export * from "./AdminUserManagementTable.vue?vue&type=script&lang=js"

import "./AdminUserManagementTable.vue?vue&type=style&index=0&id=f2c54478&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c54478"]])

export default __exports__